export function articleGallery() {
    let articleGallery = $(".article-gallery");
    let articleThumbnails = $(".article-gallery-thumbnails");
    articleGallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: articleThumbnails,
        dots: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: false
                }
            }
        ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (articleGallery.find(".slick-current").find("iframe").length) {
            articleGallery.find(".slick-current").find("iframe").remove();
        }
    });

    articleThumbnails.slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: articleGallery,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/articleGallery.js